import { Component, OnInit, Inject } from '@angular/core';
import { MODAL_CONTROLLER, ModalController } from 'shared';
import { ModalComponent } from '../../../../../shared/src/lib/components/modal/modal.component';
import { ModalContentComponent } from '../../../../../shared/src/lib/components/modal-content/modal-content.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-user-role-explainer-modal',
    templateUrl: './user-role-explainer-modal.component.html',
    styleUrls: ['./user-role-explainer-modal.component.scss'],
    imports: [
        ModalComponent,
        ModalContentComponent,
        TranslateModule,
    ]
})
export class UserRoleExplainerModalComponent {
  constructor(@Inject(MODAL_CONTROLLER) private controller: ModalController<void>) {
  }

  dismiss() {
    this.controller.dismiss();
  }
}
